const BRAND_BASE =
  window.opslevel?.brand === "tidra"
    ? "https://tidra.ai"
    : "https://www.opslevel.com";

export const PRIVACY_POLICY_URL = `${BRAND_BASE}/legal/privacy`;
export const TERMS_OF_SERVICE_URL = `${BRAND_BASE}/terms-of-service`;

const DOCS_BASE =
  window.opslevel?.brand === "tidra"
    ? "https://docs.tidra.ai"
    : "https://docs.opslevel.com";

export const ARGOCD_DEPLOY_INTEGRATION_DOC = `${DOCS_BASE}/docs/argocd`;
export const CIRCLECI_DEPLOY_INTEGRATION_DOC = `${DOCS_BASE}/docs/circleci`;
export const CLI_INTEGRATION_DOC = `${DOCS_BASE}/docs/api/cli/`;
export const CLI_DEPLOY_INTEGRATION_DOC = `${DOCS_BASE}/docs/api/cli/#deploys`;
export const CUSTOM_CHECK_DOC = `${DOCS_BASE}/docs/payload-checks`;
export const CUSTOM_EVENT_CHECK_DOC = `${DOCS_BASE}/docs/checks/custom-event/`;
export const DATADOG_INTEGRATION_DOC = `${DOCS_BASE}/docs/integrations/datadog/`;
export const DEPLOY_INTEGRATION_DOC = `${DOCS_BASE}/docs/insights/deploys/`;
export const DOCUMENTATION_URL = `${DOCS_BASE}/docs/`;
export const GIT_INTEGRATION_DOC = `${DOCS_BASE}/docs/git-integration`;
export const GITHUB_INTEGRATION_DOC = `${DOCS_BASE}/docs/github-integration`;
export const GITHUB_ACTIONS_INTEGRATION_DOC = `${DOCS_BASE}/docs/github-actions-integration`;
export const GITLAB_CI_INTEGRATION_DOC = `${DOCS_BASE}/docs/gitlab-ci-integration`;
export const GITLAB_SELF_MANAGED_INTEGRATION_DOC = `${DOCS_BASE}/docs/gitlab-self-managed`;
export const HOMEPAGE_URL = "https://www.opslevel.com";
export const JENKINS_INTEGRATION_DOC = `${DOCS_BASE}/docs/jenkins-integration`;
export const OCTOPUS_DEPLOY_INTEGRATION_DOC = `${DOCS_BASE}/docs/octopus-deploy-integration`;
export const OPSLEVEL_YAML_DOC = "https://docs.opslevel.com/docs/opslevel-yml/";
export const PAGERDUTY_INTEGRATION_DOC = `${DOCS_BASE}/docs/pagerduty/`;
export const PAYLOAD_CHECK_DOC = `${DOCS_BASE}/docs/checks/payload-checks/`;
export const REPO_FILE_CHECK_DOC = `${DOCS_BASE}/docs/repo-file-checks/#using-a-version-constraint-advanced`;
export const REPO_GREP_CHECK_DOC = `${DOCS_BASE}/docs/repo-grep-checks`;
export const SLACK_INTEGRATION_DOC = `${DOCS_BASE}/docs/slack-integration/`;
export const TAG_DEFINED_CHECK_DOC = `${DOCS_BASE}/docs/tag-defined-checks/#verify-library-version`;
export const KUBERNETES_INTEGRATION_DOC = `${DOCS_BASE}/docs/kubernetes-integration/`;
export const TERRAFORM_API_DOC = `${DOCS_BASE}/docs/terraform/`;
export const MATURITY_BADGE_DOC = `${DOCS_BASE}/docs/service-level-badges`;
export const JIRA_INTEGRATION_DOC = `${DOCS_BASE}/docs/jira-software`;
export const API_DOCS_INTEGRATION_DOC = `${DOCS_BASE}/docs/api-docs/`;
export const OPSGENIE_INTEGRATION_DOC = `${DOCS_BASE}/docs/opsgenie/`;
export const INTEGRATIONS_URL = "/integrations";
export const EXPLAIN_GLOBBING_URL =
  "https://www.baeldung.com/linux/bash-globbing";
export const AZURE_DEVOPS_INTEGRATION_DOC = `${DOCS_BASE}/docs/azure-devops`;
export const OKTA_SCIM_INTEGRATION_DOC = `${DOCS_BASE}/docs/okta-user-provisioning-with-scim`;
export const INFRASTRUCTURE_INTEGRATION_DOC = `${DOCS_BASE}/docs/infrastructure`;
export const NEW_RELIC_INTEGRATION_DOC = `${DOCS_BASE}/docs/new-relic-integration`;
export const LEVELS_DOC = `${DOCS_BASE}/docs/categories-and-levels#levels`;
export const OPSLEVEL_DEMO_LINK =
  "https://opslevel.na.chilipiper.com/book/custom-demo-request";
export const AWS_INTEGRATION_DOC = `${DOCS_BASE}/docs/import-infrastructure-objects-via-aws`;
export const AZURE_RESOURCES_INTEGRATION_DOC = `${DOCS_BASE}/docs/import-infrastructure-objects-via-azure`;
export const GOOGLE_CLOUD_INTEGRATION_DOC = `${DOCS_BASE}/docs/import-infrastructure-objects-via-google`;
export const SNYK_INTEGRATION_DOC = `${DOCS_BASE}/docs/snyk-integration`;
export const SONARQUBE_INTEGRATION_DOC = `${DOCS_BASE}/docs/sonarqube-integration`;
export const SONARQUBE_CLOUD_INTEGRATION_DOC = `${DOCS_BASE}/docs/sonarqube-cloud-integration`;
export const MICROSOFT_TEAMS_INTEGRATION_DOC = `${DOCS_BASE}/docs/microsoft-teams`;
export const INCIDENT_IO_INTEGRATION_DOC = `${DOCS_BASE}/docs/incident-io`;
export const FIRE_HYDRANT_INTEGRATION_DOC = `${DOCS_BASE}/docs/fire-hydrant`;
export const CUSTOM_INTEGRATION_DOC = `${DOCS_BASE}/docs/custom-integration`;
export const WIZ_INTEGRATION_DOC = `${DOCS_BASE}/docs/wiz-integration`;
export const ANTHROPIC_INTEGRATION_DOC = `${DOCS_BASE}/docs/anthropic-integration`;
export const AWS_CREATE_OBJECTS_DOC = `${DOCS_BASE}/docs/import-infrastructure-objects-via-aws#create-aws-objects`;
export const AWS_TAG_RELATIONSHIPS_DOC = `${DOCS_BASE}/docs/import-infrastructure-objects-via-aws#establishing-relationships-for-infrastructure-objects-via-aws-tags`;
export const CUSTOM_PROPERTIES_MAPPING_DOC = `${DOCS_BASE}/docs/mapping-integration-data-to-custom-properties`;
export const DATADOG_DOC = `${DOCS_BASE}/docs/datadog`;
export const DATADOG_REQUIREMENTS_DOC = `${DOCS_BASE}/docs/datadog#requirements`;
export const FEATURE_MANAGEMENT_DOC = `${DOCS_BASE}/docs/feature-management`;
export const GITLAB_SELF_MANAGED_INSTALL_DOC = `${DOCS_BASE}/docs/integrations/gitlab-self-managed/`;
export const OPSLEVEL_AGENT_DOC =
  "https://docs.opslevel.com/docs/opslevel-agent";
export const PACKAGE_VERSIONS_DOC = `${DOCS_BASE}/docs/package-versions`;
export const SNYK_INTEGRATION_PAYLOAD_DOC =
  "https://docs.opslevel.com/docs/snyk-integration#send-payload-to-opslevel";
export const WEBHOOK_SIGNATURES_DOC = `${DOCS_BASE}/docs/webhook-signatures`;
export const CLI_DOC = `${DOCS_BASE}/docs/cli`;
export const COMPONENT_TYPES_DOC = `${DOCS_BASE}/docs/components`;
export const CUSTOM_ACTIONS_CONTEXT_SCHEMA_DOC = `${DOCS_BASE}/docs/custom-actions-context-schema`;
export const CUSTOM_ACTIONS_GETTING_STARTED_DOC = `${DOCS_BASE}/docs/getting-started-with-custom-actions`;
export const CUSTOM_ACTIONS_MANUAL_INPUTS_DOC = `${DOCS_BASE}/docs/configuring-custom-actions-manual-inputs`;
export const CUSTOM_EVENT_LIQUID_TEMPLATING_DOC = `${DOCS_BASE}/docs/custom-event-checks#liquid-templating`;
export const RELATIONSHIP_DEFINITIONS_MANAGED_DOC = `${DOCS_BASE}/docs/relationship-definitions#managed-relationships`;
export const SERVICE_CREATION_DOC = `${DOCS_BASE}/docs/getting-started-with-service-creation`;
export const SERVICE_CREATION_WEBHOOK_SCHEMA_DOC = `${DOCS_BASE}/docs/service-creation-webhook-context-schema`;
export const SERVICE_DEPENDENCIES_REPO_DOC = `${DOCS_BASE}/docs/repositories/service-dependencies`;
export const SERVICE_DETECTION_DOC = `${DOCS_BASE}/docs/service-detection`;
export const SERVICE_DETECTION_INTEGRATIONS_DOC = `${DOCS_BASE}/docs/service-detection#detecting-services-from-integrations`;
export const UI_CUSTOMIZATION_CUSTOM_WIDGETS_DOC = `${DOCS_BASE}/docs/ui-customization#custom-widgets`;
export const UI_CUSTOMIZATION_LIQUID_TEMPLATING_DOC = `${DOCS_BASE}/docs/ui-customization#liquid-templating`;
export const UI_CUSTOMIZATION_PIE_CHART_DOC = `${DOCS_BASE}/docs/ui-customization#pie-chart-widgets`;
export const ALERT_SOURCE_USAGE_CHECK_DOC = `${DOCS_BASE}/docs/alert-source-usage-checks`;
export const API_DOCS_CHECK_DOC = `${DOCS_BASE}/docs/api-docs`;
export const BRANCH_PROTECTION_CHECK_DOC = `${DOCS_BASE}/docs/branch-protection-checks`;
export const CUSTOM_EVENT_CHECKS_DOC = `${DOCS_BASE}/docs/custom-event-checks`;
export const HAS_RECENT_DEPLOY_CHECK_DOC = `${DOCS_BASE}/docs/has-recent-deploy-checks`;
export const JQ_PREDICATE_CHECK_DOC = `${DOCS_BASE}/docs/checks/repo-file-checks/#using-a-jq-predicate-advanced`;
export const OPSLEVEL_YML_CHECK_DOC =
  "https://docs.opslevel.com/docs/opslevel-yml";
export const REPO_FILE_CHECKS_DOC = `${DOCS_BASE}/docs/repo-file-checks`;
export const REPO_SEARCH_CHECK_DOC = `${DOCS_BASE}/docs/repo-search-checks`;
export const SERVICE_CONNECTIONS_CHECK_DOC = `${DOCS_BASE}/docs/service-connections`;
export const SERVICE_DEPENDENCY_CHECK_DOC = `${DOCS_BASE}/docs/service-dependencies`;
export const TAG_DEFINED_CHECKS_DOC = `${DOCS_BASE}/docs/tag-defined-checks`;
